var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AutobuyerToggleLabel',{attrs:{"is-active":_vm.isActive,"is-disabled":_vm.isDisabled,"name":_vm.name},on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }